// @flow
import React, { type Node } from 'react';
import { isEmpty } from 'lodash';

import { Capsule } from 'Components/frameworks/capsule/Capsule.jsx';
import { CollapsePanel } from 'Components/frameworks/collapse-panel/CollapsePanel.jsx';
import { Icon, type IconName } from 'Components/frameworks/icon/Icon.jsx';

import { themes } from './CapsuleCollapseLists.themes';

type CapsuleCollapseListsProps = {
  className?: string,
  header: {
    color?: string,
    iconName?: IconName,
    title: string,
  },
  lists: ?Array<{
    items: ?Array<{
      iconName?: IconName,
      label: string,
    }>,
    title: string,
  }>,
  message?: Node,
  style?: *,
  theme?: string,
};

export function CapsuleCollapseLists(props: CapsuleCollapseListsProps) {
  const { className, header = {}, lists = [], message, style, theme = 'default' } = props;

  if (!lists || !lists.length) {
    return null;
  }

  const {
    thCollapse,
    thCollapseIconCollapse,
    thCollapseIconExpand,
    thCollapseTheme,
    thItems,
    thItem,
    thItemIcon,
    thItemIconWidth,
    thItemLabel,
    thMessage,
  } = themes[theme];

  return (
    <Capsule
      additionalStyle={{ root: style }}
      className={className}
      color={header.color}
      header="large"
      icon={header.iconName}
      label={header.title}
    >
      {!!message && <div className={thMessage}>{message}</div>}
      {lists.map(
        (el, index) =>
          !isEmpty(el.items) && (
            <CollapsePanel
              className={thCollapse}
              collapseIconName={thCollapseIconCollapse}
              expandIconName={thCollapseIconExpand}
              isExpanded={index === 0}
              key={el.title}
              theme={thCollapseTheme}
              title={el.title}
            >
              <ul className={thItems}>
                {el.items.map(({ iconName, label }) => (
                  <li className={thItem} key={label}>
                    <Icon className={thItemIcon} name={iconName} width={thItemIconWidth} />
                    <span className={thItemLabel}>{label}</span>
                  </li>
                ))}
              </ul>
            </CollapsePanel>
          ),
      )}
    </Capsule>
  );
}
